import { render, staticRenderFns } from "./ResponsibilitiesDirectoryTable.vue?vue&type=template&id=0f2fa3fb&scoped=true"
import script from "./ResponsibilitiesDirectoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilitiesDirectoryTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilitiesDirectoryTable.vue?vue&type=style&index=0&id=0f2fa3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fa3fb",
  null
  
)

export default component.exports